
import i18n from "../../i18n/index";
import authorizationsService from "../../services/authorizacions/ServiceAuthorizacions.js";
import orderService from "../../services/orders/OrderService.js"
import dayjs from "dayjs";
import XLSX from 'xlsx';

export default {
  components: {
  },
  data: () => ({
    headers: [{
      id: 0,
      text: i18n.t('headers.load-date'),
      sortable: false,
      value: "shippingDate"
  },
  {
      id: 1,
      text: i18n.t('headers.user'),
      sortable: false,
      value: "number"
  },
  {
    id: 2,
    text: i18n.t('headers.patient-name'),
    sortable: false,
    value: "number"
},
  {
      id: 3,
      text: i18n.t('headers.total-authorizations'),
      sortable: false,
      value: "patient_document"
  },
  {
      id: 4,
      text: i18n.t('headers.total-errors'),
      sortable: false,
      value: "patient_name"
  },
  {
      id: 5,
      text: i18n.t('headers.errors-detail'),
      value: "status",
      sortable: false
  },
  
  ],

  headers1: [
    { text: 'Autorizacion', value: 'orderNumber', sortable: false },
    { text: 'Tipo de identificación', value: 'identificationType', sortable: false },
    { text: 'Identificación', value: 'identification', sortable: false },
    { text: 'Proveedor', value: 'provider', sortable: false },
    { text: 'Estado', value: 'status', sortable: false },
    { text: 'Fecha de creación', value: 'creationDate', sortable: false }
  ],
  orderAutorization: '',
  searchButtonLoading: false,
  loadedOrder: false,
  updating: false,
  canDeleteAuthorization: false,
  authorizations: [],
  logs: [],
  totallogs: 0,
  rowsPerPageItems: [5, 10],
  pagination: {},
  copayments: [],
  file: '',
  loaded: false,
  loading: false,
  templateLink: 'http://104.248.183.112:3001/template/copayment',
  loading: false,
  maxDatePreviewDelivery: '',
  newStatusSelect : null,
  disabled: false 
  }),
  computed: {
    customHeaders() {
        return this.headers
    },
  },
  async created() {
    this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
    this.getLog();
  },

  watch: {
    pagination: {
      handler() {
        this.getLog();
      },
      deep: true
  }
  },

  methods: {

    async searchAutorization () {
      try {
        if (this.orderAutorization === '') {

          this.$notify({
            group: 'app',
            type: 'error',
            text: 'Por favor ingrese un número de autorización'
          })
          return
        }

        if (!/^\d+-\d+$/.test(this.orderAutorization)) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'El número de autorización no es válido'
          })
          return
        }

        this.searchButtonLoading = true
        let response = await authorizationsService.getAuthorizations(this.orderAutorization)
        console.log(response, "response")
        if (response.data.code === "No data available") {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'No existe la autorización'
          })
          
          this.loadedOrder = false;
          this.canDeleteAuthorization = false;
        } else {
          this.authorizations = response.data;
          this.loadedOrder = true;
          this.canDeleteAuthorization = this.validateCanDeleteAuthorization(response.data);
        }
        this.searchButtonLoading = false
      } catch (error) {
        this.searchButtonLoading = false
        this.canDeleteAuthorization = false;
      }      
    },

    validateCanDeleteAuthorization(authorizations) {
      if (authorizations && authorizations.length > 0) {
        const auth = authorizations[0];
        return auth.status === 'N' || auth.status === 'P';
      }
      return false;
    },

    showColumn(i) {
      return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
    },

    onChangeFileUpload() {
      if (this.$refs.file.files[0] !== undefined) {
        this.file = this.$refs.file.files[0]
        this.loaded = true
      } else {
        this.loaded = false
      }
    },
    downloadTemplate () {
      const columns = XLSX.utils.json_to_sheet([
        {autorizacion: '345-67890' , estado: 'N', nitprestador: 123456789},
        {autorizacion: '345-67891' , estado: 'P', nitprestador: 987654321},
       ])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, columns, 'autorizaciones')
      XLSX.writeFile(wb, 'plantilla_eliminacion_autorizaciones_administrador.xlsx')
    },
    async readFile () {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function (e) {
            let data = e.target.result;
            data = new Uint8Array(data);
            let workbook = XLSX.read(data, {type: 'array'});
            let result = {};
            let i = 0;
            workbook.SheetNames.forEach(function (sheetName) {
                let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                if (roa.length) {
                  result[i] = roa;
                  i++;
                }
            });
            resolve(result);
        };
        reader.onerror = function(event) {
          reader.abort();
          reject(reader.error)
        };
        reader.readAsArrayBuffer(this.file);
      });
    },
    async submitForm() {
      try {
        if (this.file !== undefined && this.file !== '') {
          this.loading = true

          const dataFromExcel = await this.readFile();
          if (dataFromExcel[0].length === 0) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: 'El archivo no contiene información'
            })
            this.loading = false
            return
          }
          if (dataFromExcel[0].length > 2000) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'El archivo no puede contener más de 2000 registros'
                });
                this.loading = false;
                return;
          }

          for (let i = 0; i < dataFromExcel[0].length; i++) {
            const row = dataFromExcel[0][i];
            if (!row.hasOwnProperty('autorizacion')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número autorización en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!row.hasOwnProperty('estado')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene el estado de la autorizacion en la linea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!row.hasOwnProperty('nitprestador')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene el nit del prestador en la linea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!/^\d+-\d+$/.test(row.autorizacion)) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de autorización válido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (row.estado !== 'N' && row.estado !== 'P') {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no tiene un estado válido (N o P) en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!/^\d+$/.test(row.nitprestador)) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de autorización válido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
          }
          const data = {
            data: dataFromExcel[0]
          }
          
          authorizationsService.bulkDeleteAuthorizacions(data).then(() => {
            console.log('La solicitud ha sido enviada.');
          }).catch(error => {
            console.error('Error al enviar la solicitud:', error);
          });
    
          this.$notify({
            group: 'app',
            type: 'success',
            text: 'La solicitud ya está siendo procesada, revise las órdenes más tarde'
          });
          this.clearFileInput();
          this.loading = false
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'No ha cargado el archivo de cambios de estado'
          })
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },

    async deleteAuthorization(){
        try {
            if (this.authorizations.length === 0) {
            this.$notify({
                group: 'app',
                type: 'error',
                text: 'No hay autorizaciones para eliminar'
            })
            return;
            }
            this.updating = true;
            const data = {
                authorization: this.authorizations[0]
            }
            await authorizationsService.deleteAuthorizacion(data);
            this.$notify({
            group: 'app',
            type: 'success',
            text: 'La solicitud de eliminación ya está siendo procesada'
            });
            this.updating = false;
            this.loadedOrder = false;
            this.canDeleteAuthorization = false;
            this.authorizations = [];
        } catch (error) {
            this.updating = false;
            this.$notify({
            group: 'app',
            type: 'error',
            text: 'Error al procesar la solicitud de eliminación'
            });
        }
    },

    clearFileInput() {
      this.$refs.file.value = '';
      this.file = '';
      this.loaded = false;
    },

    getLog(){
      this.loading = true;
      authorizationsService.getLogAuthorizationsDelete().then(
        data => {
          this.loading = false;
          this.logs = data.data;
          this.totalOrders = data.data.length;
        }
      ).catch(error => {
        console.error('Error al obtener el log de eliminaciones:', error);
        this.loading = false;
      });
    },

    formatearFecha(fechaISO) {
      const fecha = new Date(fechaISO);
    
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0'); 
      const anio = fecha.getFullYear();
    
      const horas = String(fecha.getHours()).padStart(2, '0');
      const minutos = String(fecha.getMinutes()).padStart(2, '0');
      const segundos = String(fecha.getSeconds()).padStart(2, '0');
    
      return `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos}`;
    },

    descargarCSV(errorDetail) {
      if (!errorDetail) {
        console.error('No hay datos para descargar');
        return;
      }
    
      const rows = errorDetail.split(',');
      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'errores.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    mapStatusPresentation(status) {
      switch (status) {
        case 'N': return 'Generado';
        case 'A': return 'Anulado';
        case 'P': return 'Proceso';
        case 'E': return 'Entregada';
        default: return status;
      }
    },




  }
}
